//@ts-expect-error PHP loader specific to webpack
import langsPol from "../../Config/Langs/langs_pl.php";
//@ts-expect-error PHP loader specific to webpack
import langsEng from "../../Config/Langs/langs_en.php";
//@ts-expect-error PHP loader specific to webpack
import langsCs from "../../Config/Langs/langs_cs.php";
//@ts-expect-error PHP loader specific to webpack
import langsUk from "../../Config/Langs/langs_uk.php";
//@ts-expect-error PHP loader specific to webpack
import langDe from "../../Config/Langs/langs_de.php";
//@ts-expect-error PHP loader specific to webpack
import langPt from "../../Config/Langs/langs_pt.php";
//@ts-expect-error PHP loader specific to webpack
import langEs from "../../Config/Langs/langs_es.php";
//@ts-expect-error PHP loader specific to webpack
import langHu from "../../Config/Langs/langs_hu.php";
//@ts-expect-error PHP loader specific to webpack
import langFr from "../../Config/Langs/langs_fr.php";
//@ts-expect-error PHP loader specific to webpack
import langRu from "../../Config/Langs/langs_ru.php";
//@ts-expect-error PHP loader specific to webpack
import langIt from "../../Config/Langs/langs_it.php";

import { COUNTRY_NOT_AVAILABLE } from "./consts";

const localeMap = {
    pl: langsPol,
    en: langsEng,
    cs: langsCs,
    uk: langsUk,
    de: langDe,
    pt: langPt,
    es: langEs,
    fr: langFr,
    hu: langHu,
    ru: langRu,
    it: langIt,
};

export default {
    methods: {
        translate(key, returnKeyIfMissing = false, args: Array<number | string> = []) {
            return getTranslation(key, args) || (returnKeyIfMissing ? key : null);
        },
        translateCountryCode(countryCode) {
            if (countryCode === COUNTRY_NOT_AVAILABLE) {
                return this.translate("country.unknown");
            }
            return this.translate(`country.${countryCode.toUpperCase()}`);
        },
    },
};

function getTranslation(key, args: Array<number | string> = []) {
    if (!Array.isArray(args)) {
        throw Error("Args must be array.");
    }
    if (!window.panelLocale) {
        throw Error("No locale defined.");
    }
    const langs = localeMap[window.panelLocale];
    let lang = langs[key];

    if (!lang) {
        return null;
    }

    if (args.length === 0) {
        return lang;
    }

    const matches = lang.match(/({[a-zA-Z0-9]+})/g);

    if (matches) {
        for (let i = 0; i < matches.length; i++) {
            let replacement = args[i];
            if (args[i] === null || args[i] === undefined) {
                replacement = matches[i];
            }

            lang = lang.replace(matches[i], replacement);
        }
    }

    return lang;
}
